import React from 'react';
export function SentIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 10.232L6.674 3.284a2 2 0 00-2.834 2.4L5.946 12 3.84 18.316a2 2 0 002.834 2.4l13.126-6.95a2.001 2.001 0 000-3.534zM5.738 5.052L16.974 11H7.721L5.738 5.052zm0 13.9L7.721 13h9.253L5.738 18.952z"
  }));
}